var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLaptop = function SvgIconLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 6.75v8h-.5a1 1 0 0 0-1 1V18a2.5 2.5 0 0 0 2.5 2.5h16.5a2.5 2.5 0 0 0 2.5-2.5v-2.25a1 1 0 0 0-1-1h-.5v-8a2.5 2.5 0 0 0-2.5-2.5H5.25a2.5 2.5 0 0 0-2.5 2.5m2.5-.5a.5.5 0 0 0-.5.5v8h14.5v-8a.5.5 0 0 0-.5-.5zm15.5 10.5V18a.5.5 0 0 1-.5.5H3.75a.5.5 0 0 1-.5-.5v-1.25z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconLaptop;